/* eslint-disable no-shadow, no-mixed-operators */
// todo convert this to es6

const Cookies = require('cookies-js');
const LocationService = require('../locationservice');
const Callout = require('./callout');
const HoverBox = require('./native/hover-box/hover-box.es6');
const uiLocale = require('../utils/UILocale.js');
const uiSettings = require('../utils/UISettings');

/**
 * COMPONENT tour guide
 *
 * This is used to help the user use the ui or draw attention to specific things at
 * specific times (eg 1st visit)
 */
// todo swtich to localstorage module
const options = {
  HAS_VISITED_PRODUCT_PAGE: 'HAS_VISITED_PROD_PAGE',
  HAS_VISITED_PRODUCT_LISTING_PAGE: 'HAS_VISITED_PRODUCT_LISTING_PAGE'
};

/**
 * sets up the gotit box based of various conditions, when the service is in ready state
 * @param event
 */
function readylocationStateChangeHandler(event) {
  let postcodeEl;
  let callout;
  let callToAction;
  let mobileCallout;
  const width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

  if (LocationService.getLocationState() === LocationService.LocationState.READY) {
    postcodeEl = $('[data-component="locationsearch"] input').filter(':visible')[0];
    if (postcodeEl) {
      if (!getTourGuideItem(options.HAS_VISITED_PRODUCT_PAGE)) {
        callout =
          new Callout('', window.App.locale.getString('tourguide.got_it_box.label'), 'Got it');

        // allign the callout based on device width
        if (width >= window.App.Platform.mediaQuerySetting.DESKTOP_MIN_WIDTH_PX) {
          callout.show(postcodeEl, Callout.ALIGNMENT_LEFT);
        } else if (width >= window.App.Platform.mediaQuerySetting.TABLET_MIN_WIDTH_PX) {
          callout.show(postcodeEl, Callout.ALIGNMENT_BOTTOM);
        } else if (width < window.App.Platform.mediaQuerySetting.TABLET_MIN_WIDTH_PX) {

          callToAction = function callToAction() {
            window.scrollBy(0,
              postcodeEl.getBoundingClientRect().top +
              postcodeEl.getBoundingClientRect().height / 2 -
              document.documentElement.clientHeight / 2);
          };

          // use timeout because of other compoments scroll event
          // causing the hoverbox to close around 1s mark
          mobileCallout = new HoverBox(
            uiLocale.getString('tourguide.mobile.hoverbox.content'),
            uiLocale.getString('tourguide.mobile.hoverbox.buttontext'),
            true,
            true,
            callToAction
          );
          mobileCallout.show();
        }
        setTourGuideItem(options.HAS_VISITED_PRODUCT_PAGE, true);
        LocationService.removeEventListener('locationstatechange', this);
      }
    }
  }
}

module.exports = {
  init: function() {

    // todo use michals page-resolver or find some common solution between react and vanilla
    // #####################################
    // PRODUCT PAGE
    // #####################################

    // if user tried to copy title show them a message
    // todo load url and text from json-ld settings
    const titleEl = document.querySelectorAll('.product-page .page-title')[0];
    if (titleEl) { // todo use michals page-resolver
      if (uiSettings.get('component.callout.globally-enabled')) {
        LocationService.addEventListener('locationstatechange', readylocationStateChangeHandler);
      }
    }
  }
};

// todo switch this to localstorage shim
/**
 * Gets item from local storage or fallback for cookies (for safari private mode)
 * @param key
 * @returns {*}
 */
function getTourGuideItem(key) {
  if (!window.isLocalStorageWorking) {
    return Cookies.get(key);
  }
  return localStorage.getItem(key);
}

/**
 * Sets item from local storage or fallback for cookies (for safari private mode)
 * @param key
 * @param value
 * @returns {*}
 */
function setTourGuideItem(key, value) {
  if (!window.isLocalStorageWorking) {
    return Cookies.set(key, value);
  }
  return localStorage.setItem(key, value);
}
